export default {
    // --------Title--------
    container: 'Container',
    registeredContainerInformation: 'Registered container information',
    detailInformationAboutTheItemsInvolved: 'Detail information about the items involved',
    selectThePackingDocumentToImport: 'Select the packing document to import',
    provideInformationAboutContainer: 'Provide information about container',
    availableProducts: 'Available Products',
    availableItems: 'Available Items',
    containerInformation: 'Container Information',
    detailsInformationAboutContainer: 'Details information about container',
    searchSupplierNoOrSignedByOrMarking: `Search Supplier/Company/PNo. / Signed By / Marking`,

    // --------Dialog & Drawer Title-------
    addContainerItems: 'Add Container Items',
    customerMarking: 'Customer Marking',
    searchCustomerDetailsByMarking: 'Search customer details by marking',
    searchCustomerByMarking: 'Search Customer By Marking',
    updateContainerInformation: 'Update Container Information',
    relatedWarehouseLocationToProcess: 'Related warehouse location to process',
    fileName: 'Filename :',
    calculateTheSummaryOfTheContainerInformationPerformValidationBeforeImportIntoSystem: 'Let system to calculate the summary of the container information, perform validation before import into system',
    updateRemark: 'Update Remark',

    // ----------MUI--------
    marking: 'Marking',
    repositoryNo: 'Repository No.',
    repositoryAltNo: 'Repository Alt No.',
    containerNo: 'Container No.',
    secondaryNo: 'Secondary No.',
    sealNo: 'Seal No.',
    loadDate: 'Load Date',
    customAgent: 'Custom Agent',
    addItem: 'Add Item',

    locationName: 'Location Name',
    destinationLocation: 'Destination Location',
    action: 'Action',
    containerSize: 'Container Size',
    containerType: 'Container Type',
    repositoryMarking: 'Repository Marking',
    initialDate: 'Initial Date',
    supervisor: 'Supervisor',
    shipper: 'Shipper',
    totalPackQty: 'Total Pack Qty',
    totalValues: 'Total Values',
    totalWeight: 'Total Weight',
    totalCbm: 'Total CBM',
    profileInformation: 'Profile Information',
    code: 'Code',

    assignItems: 'Assign Items',
    status: 'Status',
    courierNo: 'Courier No.',
    purchaseNo: 'Purchase No.',
    packQty: 'Pack Qty',
    values: 'Values',
    weight: 'Weight',
    qty: 'Qty',
    signedBy: 'Signed By',
    no: 'No.',
    dimension: 'Dimension (LxHxW)',
    used: 'Used',
    loadQty: 'Load Qty',
    createDateTime: 'Create Date Time',
    uploadFile: 'Upload File',
    downloadTemplate: 'Download Template',
    confirmImport: 'Confirm Import',

}